import type { SnackList } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

/** SelectField は値が空文字の選択肢を出さないため、「未設定」には別の値を当てる */
export const DEFAULT_TOP_PAGE_VALUE = "default";

type Props = {
	snackList: SnackList;
	topPageSnackUUID: string | null | undefined;
};

export const snackListToTopPageSnackOptions = ({ snackList, topPageSnackUUID }: Props): FormOptionType[] => {
	const publishedSnacks = snackList.snacks.filter((snack) => snack.isPublished);
	const isTopPageSnackUnavailable =
		!!topPageSnackUUID && !publishedSnacks.some((snack) => snack.uuid === topPageSnackUUID);

	return [
		{ id: DEFAULT_TOP_PAGE_VALUE, label: "未設定（レイアウト設定の内容）", value: DEFAULT_TOP_PAGE_VALUE },
		...(isTopPageSnackUnavailable
			? [
					{
						id: topPageSnackUUID,
						label: "設定中のスナック（非公開または削除済み）",
						value: topPageSnackUUID,
						disabled: true,
					},
				]
			: []),
		...publishedSnacks.map((snack) => ({
			id: snack.uuid,
			label: snack.title || "タイトル未設定",
			value: snack.uuid,
		})),
	];
};
